import { type EditorModel, type SetComplexImmerStateAction } from '@/lib/types';
import dummyFunction from '@/lib/utils/dummyFunction';
import { createContext } from 'react';

const ModelsContext = createContext<
  [
    Record<number, EditorModel>,
    SetComplexImmerStateAction<Record<number, EditorModel>>,
  ]
>([{}, dummyFunction]);

export default ModelsContext;
